// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderForm_container__2ZZx3","boxes":"OrderForm_boxes__3Rjtr","icon":"OrderForm_icon__2PUe6","formGroup":"OrderForm_formGroup__1p7DD"};